export default __webpack_public_path__ + "static/media/pngegg.83dfa097.png";